import { Button, Input } from "antd";
import { useState } from "react";
import { validateEmail } from "../utils/commonUtils";

function parseEmailInput(raw) {
  if (!raw?.trim()) return [];
  return raw
    .split(/[,，;\s]+/)
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

function EmailComponent({ parentKey, field, emailList, setErrorObj }) {
  const [emailInput, setEmailInput] = useState("");
  const handleAddEmailList = () => {
    const values = parseEmailInput(emailInput);
    if (values.length === 0) return;
    const invalid = values.filter((e) => !validateEmail(e));
    if (invalid.length > 0) {
      setErrorObj({
        "Email notification": "Please enter a valid email address.",
      });
      return;
    }
    const current = emailList || [];
    const seen = new Set(current);
    const toAdd = values.filter((e) => !seen.has(e) && (seen.add(e), true));
    if (toAdd.length > 0) {
      field.onchange(parentKey, field?.key, [...current, ...toAdd]);
      setEmailInput("");
      setErrorObj(null);
    }
  };
  const handleEmailRemove = (email) => {
    field?.onchange(
      parentKey,
      field?.key,
      emailList.filter((obj) => obj !== email)
    );
  };
  return (
    <div className="block">
      <div className="d-flex align-items-center">
        <Input
          className="hs-bg-off-white mx-2 w-50 h-45 focus-border"
          placeholder={field?.placeholder}
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") {
              e.preventDefault();
              handleAddEmailList();
            }
          }}
          type="email"
        />
        <Button className="hs-btn-small" onClick={handleAddEmailList}>
          Add
        </Button>
      </div>
      {emailList?.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mt-2 align-items-center">
          {emailList.map((email, index) => (
            <div
              key={email + index}
              className="email-list-item-setting d-flex align-items-center gap-1 px-2 py-1"
            >
              <span className="text-break">{email}</span>
              <div
                className="actionIconsSprite closeIconBlack flex-shrink-0"
                style={{ cursor: "pointer" }}
                onClick={() => handleEmailRemove(email)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && handleEmailRemove(email)}
                aria-label={`Remove ${email}`}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default EmailComponent;
